













import { defineComponent, PropType } from '@nuxtjs/composition-api';

type FeatureProgressBarType = 'default' | 'extra-info';

export default defineComponent({
  name: 'FeatureProgressBar',
  props: {
    percentage: {
      type: Number,
      required: true,
      validator: (value) => value >= 0 && value <= 100
    },
    feature: {
      type: String,
      required: true
    },
    count: {
      type: Number,
      default: 0,
      validator: (value) => value >= 0
    },
    ratingText: {
      type: String,
      default: ''
    },
    type: {
      type: String as PropType<FeatureProgressBarType>,
      default: 'default'
    }
  }
});
